
@switch (result?.allRecordsMatch) {
  @case (true) {
    <mat-icon class="green">check_circle_filled</mat-icon>
  }
  @case (false) {
    <mat-icon class="red">error</mat-icon>
  }
}
